// eslint-disable-next-line jira/restricted/react
import React, { PureComponent, type ComponentType, type SyntheticEvent } from 'react';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import Button from '@atlaskit/button/standard-button';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import ModalDialog, {
	ModalTransition,
	ModalBody,
	ModalTitle,
	ModalHeader,
} from '@atlaskit/modal-dialog';
import ShortcutScope from '@atlassian/jira-common-components-keyboard-shortcuts/src/shortcut-scope.tsx';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import type { IntlShapeV2 as IntlShape } from '@atlassian/jira-intl/src/v2/types.tsx';
import commonMessages from '@atlassian/jira-servicedesk-common/src/i18n';
import {
	type SubmitStatus,
	SUBMIT_COMPLETED_STATUS,
} from '@atlassian/jira-servicedesk-common/src/ui/components/submit-button/model.tsx';
import SubmitButton from '@atlassian/jira-servicedesk-common/src/ui/components/submit-button/view';
import messages from './messages';
import { Footer } from './styled';

export type Props = {
	isOpen: boolean;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	ContentComponent: ComponentType<any>;
	storedRunAsUserAccountId: string;
	submitStatus: SubmitStatus;
	onSave: (arg1: string, arg2: UIAnalyticsEvent | undefined) => void;
	onClose: () => void;
	intl: IntlShape;
};

type State = {
	selectedUserAccountId: string;
};

// eslint-disable-next-line jira/react/no-class-components
class MisconfiguredSettingsDialog extends PureComponent<Props, State> {
	state = {
		selectedUserAccountId: this.props.storedRunAsUserAccountId,
	};

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	onUserSelected = (selectedUser: any) => {
		this.setState({
			selectedUserAccountId: selectedUser.accountId,
		});
	};

	onSave = (_: SyntheticEvent<HTMLElement>, analyticsEvent: UIAnalyticsEvent) => {
		this.props.onSave(this.state.selectedUserAccountId, analyticsEvent);
	};

	render() {
		const {
			intl: { formatMessage },
			isOpen,
			storedRunAsUserAccountId,
			ContentComponent,
			submitStatus,
			onClose,
		} = this.props;
		const { selectedUserAccountId } = this.state;
		if (!isOpen) {
			return null;
		}
		const isDirty = storedRunAsUserAccountId !== selectedUserAccountId;

		return (
			<ModalTransition>
				{isOpen && (
					<ShortcutScope>
						<ModalDialog onClose={onClose} width="medium">
							<ModalHeader>
								<ModalTitle>{formatMessage(messages.title)}</ModalTitle>
							</ModalHeader>

							<ModalBody>
								<ContentComponent onSelect={this.onUserSelected} />
								<Footer>
									<SubmitButton
										onSubmit={this.onSave}
										// Re-enable the button for the brief moment where the submit has completed and the state is no longer dirty
										isDisabled={!isDirty && submitStatus !== SUBMIT_COMPLETED_STATUS}
										submitStatus={submitStatus}
									/>
									<Button appearance="link" onClick={onClose} isDisabled={submitStatus !== null}>
										{formatMessage(commonMessages.cancel)}
									</Button>
								</Footer>
							</ModalBody>
						</ModalDialog>
					</ShortcutScope>
				)}
			</ModalTransition>
		);
	}
}

export default injectIntl(MisconfiguredSettingsDialog);
